<template>
    <div class="csp csp-word-text">
        <SubHeader
                v-if="!titleHide"
                :title="page.title" />
        <!-- 正文渲染区：irobot-render 可反复灌入 htmlStr -->
        <div
          ref="body"
          class="body"></div>
    </div>
</template>

<script>

  import mixin from 'cars-framework-app/src/resource/common/mixin'
  import SubHeader from '../components/sub-header/index'
  import { renderPage } from 'irobot-render'
  import 'irobot-render/style.css'
  import { getCspWordText } from '@/network'
  import NativeSdk from "@/utils/nativeSdk"

  export default {
    components: {
      SubHeader,
    },
    mixins: [mixin],
    data() {
      return {
        titleHide: this.$route.query.hideHeader == 'true',
        page: {},
        handle: null,
      }
    },
    created() {
      this.$requestManage([this.getInfo]).then(() => {
        CarsBus.emit('initReady')
      })
    },
    mounted() {
      // source-tag: evidence(有据) units/02 伪代码；沿用现网 capture 点击 data-link
      document.body.addEventListener('click', this.onDataLinkClick, true)
    },
    beforeDestroy() {
      document.body.removeEventListener('click', this.onDataLinkClick, true)
      if (this.handle) {
        this.handle.destroy()
        this.handle = null
      }
    },
    methods: {
      getInfo() {
        const params = {
          path: this.$route.query.path,
          platformKey: this.$route.query.platformKey,
          businessType: this.$route.query.businessType,
        }
        return getCspWordText(params).then((res) => {
          const response = res.data || {}
          const pageInfoX = JSON.parse(response.json) || {}
          const { title = '', htmlStr = '', quickNav = false } = pageInfoX
          if (title) {
            document.title = title
          }
          this.page = { title, htmlStr, quickNav }
          this.paint()
        })
      },
      // source-tag: evidence(有据) units/02 paint；首帧 mount，后续复用 handle.update
      paint() {
        if (!this.$refs.body) {
          return
        }
        if (this.handle) {
          this.handle.update(this.page)
          return
        }
        this.handle = renderPage(this.$refs.body, this.page)
      },
      onDataLinkClick(event) {
        const eventpath = event.composedPath ? event.composedPath() : event.path
        if (!eventpath) return
        for (let i = 0; i < eventpath.length; i++) {
          if (!(eventpath[i].getAttribute && eventpath[i].getAttribute('data-link'))) continue
          let linkData = eventpath[i].getAttribute('data-link')
          if ($CA.util.env.isApp) {
            // feat: 判断data-link是否为拨打电话 tel:xxx，否则打开对应链接地址
            if (linkData && linkData.indexOf('tel:') > -1) {
              NativeSdk.makePhoneCall({
                number: linkData.split('tel:')[1],
              })
            } else {
              const hideTitleBar = /cartool|chesupai/.test(linkData) && /chesupai/.test(window.navigator.userAgent)
              NativeSdk.createWebview({
                url: linkData,
                title: this.page.title,
                showTitleBar: !hideTitleBar,
              })
            }
          } else {
            // 链接直接跳转
            window.location.href = linkData
          }
        }
      },
    },
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>
